<template>
  <v-card>
    <v-toolbar dense flat dark :color="toolbarColor">
      <v-toolbar-title>
        <span class="font-weight-light body-1" 
          v-html="getExpression('FormTitle', 'SelectContentType').replace('{0}', label)">
        </span>
      </v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-btn @click="cancel()" fab small :color="toolbarColorDark" class="elevation-0">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-list-item-group>

      <v-list-item @click="select('audio')" :disabled="isDisabled('audio')">
        <v-list-item-avatar>
          <v-icon>audiotrack</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>
          {{ getExpression('MenuItem', 'UploadAudio') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="select('image')" :disabled="isDisabled('image')">
        <v-list-item-avatar>
          <v-icon>photo</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>
          {{ getExpression('MenuItem', 'UploadImages') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="select('video')" :disabled="isDisabled('video')">
        <v-list-item-avatar>
          <v-icon>movie</v-icon>
        </v-list-item-avatar>

        <v-list-item-title>
          {{ getExpression('MenuItem', 'UploadVideos') }}
        </v-list-item-title>
      </v-list-item>

      <template v-if="showLibrary">
        <v-divider />

        <v-list-item @click="select('library')">
          <v-list-item-avatar>
            <v-icon>folder_shared</v-icon>
          </v-list-item-avatar>

          <v-list-item-title>
            {{ getExpression('MenuItem', 'PickFromLibrary') }}
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-list-item-group>
  </v-card>
</template>

<script>
import { AppColor } from '@/config.js'

export default {
  name: 'ContentTypeSelector',
  props: {
    label: {
      type: String,
      default: 'Content'
    },
    showLibrary: {
      type: Boolean,
      default: true
    },
    disabledTypes: {
      type: Array,
      default: null
    },
    toolbarColor: {
      type: String,
      default: AppColor.Medium
    },
    toolbarColorDark: {
      type: String,
      default: AppColor.Dark
    }
  },
  methods: {
    isDisabled(type) {
      if (this.disabledTypes === null) return false
      return this.disabledTypes.filter(t => t === type).length > 0
    },
    select (contentType) {
      this.$emit('select', contentType)
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>